/** @jsx jsx */
import { jsx } from '@emotion/core';
// TODO: Import useCallback when resendSms has been implemented for magic link feature
import React, { Fragment } from 'react';
import { Field, FieldProps, Form, FormikProps } from 'formik';
import useTranslate from 'hooks/useTranslate';
import {
  useMarkdownTranslate,
  useMarkdownMultilineTranslate,
} from 'hooks/useTranslate/useTranslate';
import Button from 'components/Button';
import CancelButton from 'features/CancelButton';
import PageContainer from 'components/PageContainer';
import { FormTextField } from 'components/TextField';
import ActionButtonContainer from 'components/ActionButtonsContainer';
import Title from 'components/Title';
import { FormValues } from './MagicLinkOtpVerification';
import styles from './styles';
/** TODO: uncomment when resendSms has been implemented for magic link feature */
// import InlineButton from 'components/InlineButton';
import { useFormattedMobilePhone } from 'utils/formatUtils';

type PropTypes = FormikProps<FormValues> & {
  mobilePhone: string;
  /** TODO: uncomment when resendSms has been implemented for magic link feature */
  // resendSms: () => Promise<unknown>;
  attemptsRemaining: string | null;
  tooManyAttempts: boolean;
  timedOut: boolean;
};

const MagicLinkOtpVerificationView: React.FC<PropTypes> = props => {
  const {
    isValid,
    isSubmitting,
    /** TODO: uncomment when resendSms has been implemented for magic link feature */
    //resendSms,
    attemptsRemaining,
    tooManyAttempts,
    timedOut,
    mobilePhone,
    /** TODO: uncomment when resendSms has been implemented for magic link feature */
    //resetForm,
  } = props;

  const t = useTranslate();
  const tMd = useMarkdownTranslate();
  const tMdMultiline = useMarkdownMultilineTranslate();

  /** TODO: uncomment when resendSms has been implemented for magic link feature
  const handleResend = useCallback(async () => {
    await resendSms();
    resetForm();
  }, [resendSms, resetForm]);
  */

  const formattedMobilePhone = useFormattedMobilePhone(mobilePhone);

  return (
    <Fragment>
      <PageContainer
        maxWidth="sm"
        data-testid="magic-link-otp-verification-view"
      >
        <Form data-testid="otp-form" noValidate>
          <div css={styles.headingContainer}>
            <Title>{tMd('magicLink.otpVerification.title')}</Title>
          </div>
          <div css={styles.body}>
            {tMdMultiline('magicLink.otpVerification.instructional', {
              mobilePhone: formattedMobilePhone,
            })}
          </div>
          <div css={styles.formFields}>
            {timedOut ? (
              <div>
                <p css={styles.errorText}>
                  {tMd('magicLink.otpVerification.timedOut')}
                </p>
              </div>
            ) : null}
            <Field name="otpCode">
              {(fieldProps: FieldProps) => (
                <FormTextField
                  id="otpCode"
                  fieldProps={fieldProps}
                  label={t('magicLink.otpVerification.formLabel.otpCode')}
                  inputProps={{
                    inputMode: 'numeric',
                    pattern: '[0-9]*',
                    maxLength: 6,
                  }}
                  error={Boolean(attemptsRemaining)}
                  helperText={attemptsRemaining}
                  disabled={tooManyAttempts || timedOut}
                />
              )}
            </Field>
          </div>
          <ActionButtonContainer>
            <Button
              mobileFullWidth={true}
              type="submit"
              id="formSubmit"
              disabled={!isValid || isSubmitting || tooManyAttempts || timedOut}
              loading={isSubmitting}
            >
              {tMd('magicLink.otpVerification.submitButton')}
            </Button>
            <CancelButton />
          </ActionButtonContainer>
        </Form>
      </PageContainer>
    </Fragment>
  );
};

export default MagicLinkOtpVerificationView;
